import { Label, Stack, TextField } from "@fluentui/react";
import React from "react";
import COLORES from "../../utils/theme/colores";

interface IDescripcionDetallePersona {
  label: string | undefined;
  placeholder: string | undefined;
}

export const DescripcionDetallePersona = (
  props: IDescripcionDetallePersona
) => {
  return (
    <>
      <Stack
        horizontal
        horizontalAlign="space-between"
        className="ms-depth-8 ms-fontColor-themePrimary--hover"
        style={{
          display: "flex",
          marginBottom: 15,
          justifyContent: "space-between",
          height: 35,
        }}
        verticalAlign="center"
      >
        <Label style={{ paddingLeft: 5 }}>{props?.label}</Label>
        <TextField
          borderless
          value={props?.placeholder}
          style={{ minWidth: "300px", maxWidth: "300px" }}
          styles={{
            root: { height: 25 },
            fieldGroup: {
              height: 25,
              background: COLORES.Bases.blueLigth,
            },
          }}
        />
      </Stack>
    </>
  );
};
